import { usePendingSaves } from "../../../../../../common/input/pendingSaves";
import { useDebouncedSave } from "../../../../../../common/input/useDebouncedSave";
import { recheckHeldValuesAfter } from "../../../heldExtensionValues";
import { useTranslation } from "react-i18next";
import { DateFormControl } from "../../../../../../common/input/DateTimeSelectors/DateFormControl";
import { useAppDispatch } from "../../../../../../common/redux/hooks";
import { containsError } from "../../../../../../common/redux/reducers/contractReducer";
import { editContractThunk } from "../../../../../../common/redux/thunks/contract/edit-contract-thunk";
import { requireDataFields } from "../../../../typeguards";
import { useContractState } from "../../../useContractState";
import { useDeadlineBeforeStartRefusal } from "./useDeadlineBeforeStartRefusal";

interface Props {
  removeDataField?: () => Promise<void>;
  isRequiredButNotProvided: boolean;
}

export const StartDate = ({ removeDataField, isRequiredButNotProvided }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const contractState = useContractState();
  const dataFields = requireDataFields(contractState.contract);
  const deadlineRefusal = useDeadlineBeforeStartRefusal("EditStartDate");
  const errorMessage = deadlineRefusal ?? (containsError(contractState, "EditStartDate") ? t("Update failed") : null);

  const pendingSaves = usePendingSaves();
  const handleDateChange = useDebouncedSave(async (newDate: string | undefined) => {
    const saved = await dispatch(editContractThunk({ command: { type: "EditStartDate", value: newDate } }));
    await recheckHeldValuesAfter(pendingSaves, saved);
  });

  return (
    <DateFormControl
      id={"startDate"}
      title={t("Start date")}
      helperText={t("Provide a start date")}
      defaultDate={dataFields.startDate ?? undefined}
      errorMessage={errorMessage}
      onChange={(newDate) => {
        handleDateChange(newDate);
      }}
      removeDataField={removeDataField}
      isRequiredButNotProvided={isRequiredButNotProvided}
    />
  );
};
